import { RequestSource } from '@domgen/dgx-fe-common';
import { ProgressionStep } from '@domgen/dgx-fe-components/progress';
import { CheckoutCardConfig } from '../checkout-card/checkout-card-config.type';
import { CheckoutDirectDebitConfig } from '../checkout-direct-debit/checkout-direct-debit-config.type';
import { MentionMeConfig } from '../mention-me/mention-me-config.interface';
import { CheckoutFeatures } from './checkout-features.type';

export interface CheckoutConfig {
  applianceCareNumberOfWorkingDaysNotification?: number;
  basketApi: string;
  boilerCareNumberOfWorkingDaysNotification?: number;
  card?: CheckoutCardConfig;
  catalogueStore?: RequestSource;
  commonApi: string;
  directDebit?: CheckoutDirectDebitConfig;
  features: CheckoutFeatures;
  mentionMe?: MentionMeConfig;
  monthlyRenewalFieldEnabledStates?: string[];
  progressionSteps?: ProgressionStep[];
  promotionFirstPaymentTitle?: string;
}
